
import { ScrapReasonWorkplaceStationModel, StationModel } from '@/libs/Api';
import Page from '@/Page.vue';
import { Component, Prop, VModel, Watch } from 'vue-property-decorator';
import { stationsStore } from '@/libs/stations/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';

@Component({})
export default class ScrapReasonWorkplaceStationList extends Page {
    workplaceStations: ScrapReasonWorkplaceStationModel[] = [];
    @Prop() workplaceId!: string;
    @Prop() inputValue!: ScrapReasonWorkplaceStationModel[];

    @Watch("inputValue")
    inputValueChanged(e: ScrapReasonWorkplaceStationModel[]) {
        this.workplaceStations = e;
    }

    mounted() {
        if (this.inputValue) {
            this.workplaceStations = this.inputValue;
        }
    }

    get stations(): StationModel[] {
        let items: StationModel[] = stationsStore.useGetter(CrudGetter.Data) ?? [];
        return items
            .filter((x) => x.workplaceId == this.workplaceId)
            .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
    }

    isSelected(stationId: string): boolean {
        return this.workplaceStations?.some((x) => x.stationId == stationId);
    }

    onSelectChange(stationId: string) {
        const items = [...(this.workplaceStations ?? [])];
        if (this.isSelected(stationId)) {
            items.splice(items.indexOf(items.find((x) => x.stationId == stationId)!), 1);
        } else {
            items.push({
                stationId: stationId,
            });
        }
        this.inputValue = items;
        this.$emit('change', items);
    }
}
